module.exports = __webpack_public_path__ + "static/media/passport.2a5a2752.svg";